import $ from 'jquery'


let $gallery;
let galleryMsnry;

function initImageGallery() {
    $(window).on('load', function () {
        //console.log("init IMG gallery");

        // pub-component main component-image-gallery wp-block-mkl-section-block alignfullll
        $gallery = $('.component-image-gallery-wrapper').masonry({
            itemSelector: '.gallery-tile',
            columnWidth: '.gallery-sizer',
            // percentPosition: true,
            originLeft: false,
            // originTop: false,

            // gutter: '.gallery-gutter',
            // gutter: 0, //30,
            // fitWidth: true,
            transitionDuration: '0.2s',
            // horizontalOrder: true,
            // resize: true,
            // stagger: 30,
            // height: auto,
            // columnWidth: 10%,
        });



        // get Masonry instance
        galleryMsnry = $gallery.data('masonry');


        //
        // setTimeout(function () {
        //
        //     //console.log("masonry INIT");
        //     // $("body").removeClass("initMsnry");
        //     // $('.c-pub-postgrid__listitem').addClass('loaded');
        //
        //
        //     $gallery = $('.component-image-gallery-wrapper.grid').masonry({
        //         itemSelector: '.gallery-tile',
        //         columnWidth: '.gallery-sizer',
        //         percentPosition: true,
        //         gutter: 30,
        //         transitionDuration: '0.2s',
        //         // stagger: 30,
        //     });
        //
        //     galleryMsnry = $gallery.data('masonry');
        //     // $('.c-pub-postgrid__list').masonry();
        // }, 1000);


    })


}


export default initImageGallery

